import { render, staticRenderFns } from "./OrgModeration.vue?vue&type=template&id=00b494b2&scoped=true"
import script from "./OrgModeration.vue?vue&type=script&lang=js"
export * from "./OrgModeration.vue?vue&type=script&lang=js"
import style0 from "./OrgModeration.vue?vue&type=style&index=0&id=00b494b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b494b2",
  null
  
)

export default component.exports